// src/utils.js  
export function formatTimeAgo(timestampInSeconds) {  
    // 将秒级时间戳转换为毫秒级  
    const timestampInMilliseconds = timestampInSeconds * 1000; 
    const now = new Date().getTime();  
    const diff = now - timestampInMilliseconds;  
    const oneDay = 24 * 60 * 60 * 1000;  
    const oneHour = 60 * 60 * 1000;  
    const oneMinute = 60 * 1000;  
    const oneSecond = 1000;  
    
    if (diff < oneSecond) {  
      return '刚刚';  
    } else if (diff < oneMinute) {  
      return Math.ceil(diff / oneSecond) + '秒前';  
    } else if (diff < oneHour) {  
      return Math.ceil(diff / oneMinute) + '分钟前';  
    } else if (diff < oneDay) {  
      return Math.ceil(diff / oneHour) + '小时前';  
    } else {  
      const date = new Date(timestampInMilliseconds);  
      const year = date.getFullYear();  
      const month = date.getMonth() + 1;  
      const day = date.getDate();  
      return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;  
    }  
  }